import React from "react";
import classnames from "classnames";
import "./AnimatedProgressBar.less";

export type AnimatedProgressBarBackgroundColor = "light-grey" | "grey" | "white" | "black" | "purple";
export type AnimatedProgressBarColor = "light-grey" | "white" | "purple" | "grey" | "black";

interface AnimatedProgressBarProps {
    backgroundColor?: AnimatedProgressBarBackgroundColor;
    color?: AnimatedProgressBarColor;
    noMarginTop?: boolean;
    noMarginBottom?: boolean;
}

const AnimatedProgressBar: React.FC<AnimatedProgressBarProps> = ({
    backgroundColor = "grey",
    color = "purple",
    noMarginTop,
    noMarginBottom,
}) => (
    <div
        className={classnames("animated-progress-bar", {
            [`animated-progress-bar-color--${backgroundColor}`]: backgroundColor,
            "animated-progress-bar--no-margin-top": noMarginTop,
            "animated-progress-bar--no-margin-bottom": noMarginBottom,
        })}
    >
        <div
            className={classnames("indeterminate", {
                [`animated-progress-bar-color--${color}`]: color,
            })}
        />
    </div>
);

export default AnimatedProgressBar;
